import { function_ABM_IMP_Terminales_Leer } from "neftis7_apicaller/src/funciones/ABM/IMP/ABM_IMP_Terminales";
import { function_ABM_ZON_Companias_Leer } from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Companias";
import { FormateoFechaPara_ddMMyyyy } from "neftis7_apicaller/src/funciones/Varios";

export async function function_AsignacionDeTerminal(Terminal, ConAvisoDeTerminalCero = true) {
    let terminal = 0;
    try {
        const resultTerminal = await function_ABM_IMP_Terminales_Leer(Terminal)

        if (resultTerminal && resultTerminal.data && resultTerminal.data.length > 0) {
            localStorage.setItem("Terminal", Terminal);
            terminal = Terminal
        } else {
            localStorage.setItem("Terminal", 0);
            terminal = 0
            if (ConAvisoDeTerminalCero) {
                alert("Debe ingresar un número de Terminal válido para continuar.");
            }
        }
    } catch (error) {
        localStorage.setItem("Terminal", 0);
        terminal = 0
        if (ConAvisoDeTerminalCero) {
            alert("Debe ingresar un número de Terminal válido para continuar.");
        }
        throw error;
    }

    return terminal;
}

export const function_base64ToHex = (base64) => {
    const binary = atob(base64); // Decodificar Base64 a binario
    let hex = "0x"; // Prefijo hexadecimal
    for (let i = 0; i < binary.length; i++) {
        const byte = binary.charCodeAt(i).toString(16).padStart(2, "0");
        hex += byte;
    }
    return hex;
};

export const function_VerificacionDeCompaniaAutorizada = async () => {
    let Valido = true;

    const resultCompaniaAutorizada = await function_ABM_ZON_Companias_Leer(localStorage.getItem("CodigoCompania"))
    const fechaProximoVencimiento = resultCompaniaAutorizada.data[0].ProximoVencimiento
    const diasAvisoAntesDeVencimiento = resultCompaniaAutorizada.data[0].DiasAvisoAntesDeVencimiento
    const diasAvisoDespuesDeVencimiento = resultCompaniaAutorizada.data[0].DiasAvisoDespuesDeVencimiento
    const diasCorteDespuesDeVencimiento = resultCompaniaAutorizada.data[0].DiasCorteDespuesDeVencimiento
    const fechaActual = new Date();
    const fechaAviso = new Date(fechaProximoVencimiento);
    fechaAviso.setDate(fechaAviso.getDate() - diasAvisoAntesDeVencimiento);

    const fechaCorte = new Date(fechaProximoVencimiento);
    fechaCorte.setDate(fechaCorte.getDate() + diasCorteDespuesDeVencimiento);

    // 🔒 Si la fecha actual supera la fecha de corte, redirigir al login
    if (fechaActual > fechaCorte) {
        Valido = false;
        alert("El servicio ha sido suspendido por falta de pago. Por favor comuníquese con el sector Administrativo de Latitud Virtual para poder abonar la deuda y el cargo de reconexión y así reestablecer el servicio.");
    }

    // 🚨 Si la fecha actual es mayor que la fecha de aviso, mostrar alerta
    if (fechaActual > fechaAviso) {
        if (Valido) {
            alert("Recuerde que ya se encuentra emitida su próxima Factura y nos encontramos a muy pocos días del vencimiento ( Fecha de vencimiento: " + FormateoFechaPara_ddMMyyyy(fechaProximoVencimiento) + ".");
        }
    }

    console.log(Valido)
    return Valido;
};

export const validarEMail = (eMail) => {
    if (!eMail || typeof eMail !== 'string') return false;
  
    const correoLimpio = eMail.trim();
  
    // Controles específicos
    if (!correoLimpio) return false; // Correo vacío
    if (correoLimpio === '.') return false; // Solo un punto
    if (!/\S+@\S+\.\S+/.test(correoLimpio)) return false; // No cumple formato básico de correo
  
    // Control opcional: evitar dominios temporales conocidos
    const dominiosNoValidos = ['tempmail.com', '10minutemail.com', 'fakeinbox.com'];
    const dominio = correoLimpio.split('@')[1];
    if (dominiosNoValidos.includes(dominio)) return false;
  
    return correoLimpio; // Devuelve el correo limpio si pasa todos los controles
  };